import { CalculationType, IBayesianNetwork } from '../bayesian-networks-interfaces';

const MAX_LEVEL = 100;

const getPureLetters = (text: string): Set<string> => {
    const formatted = text; //.replaceAll('~', '');
    const parts = formatted.split(/[|,]/).map(item => item.trim());
    return new Set(parts);
};

const isSubset = (parentSet: Set<String>, childSet: Set<string>) => {
    for(const item of childSet) {
        if(!parentSet.has(item)) return false;
    }
    return true;
};

export const getRulesForMarginalExpansion = (
    results: Map<string, number>,
    rule: string,
): string[] => {

    const items = results.keys();
    const rules: Set<string> = new Set();
    const rulesMap: Map<string, string[]> = new Map(); // not in rule letters combination ---> rules
    const ruleLetters = getPureLetters(rule);

    for(const item of items) {
        const itemLetters = getPureLetters(item);
        if(isSubset(itemLetters, ruleLetters)) {

            const lettersNotInRule = new Set<string>();
            for(const item of itemLetters) {
                if(!ruleLetters.has(item)) {
                    lettersNotInRule.add(item);
                }
            }
            const lettersNotInRuleArr = [...lettersNotInRule];

            const lettersNotInRuleKeyArr = lettersNotInRuleArr.map(item => item.replace('~', ''));
            lettersNotInRuleKeyArr.sort((a, b) => a <= b ? -1 : 1);
            const lettersNotInRuleKey = lettersNotInRuleKeyArr.join('-');

            const arr = rulesMap.get(lettersNotInRuleKey) || [];
            const ruleToAdd = item.split(/[|,]/).map(_item => _item.trim()).join(',');
            arr.push(ruleToAdd);
            rulesMap.set(lettersNotInRuleKey, arr);

            rules.add(ruleToAdd);
        }
    }

    const arr = [...rulesMap.keys()];
    arr.sort((a, b) => a <= b ? -1 : 1);

    for(const item of arr) {
        const count = item.split('-').length;

        const values: string[] = rulesMap.get(item);
        if(values.length === (2 ** count)){
            return values;
        }
    }

    return []; // [...rules];
};

export const addInUseRule = (calculationTypesMap: Map<string, Set<CalculationType>>, rule: string, type: CalculationType) => {
    let set = calculationTypesMap.get(rule);
    if(!set) {
        set = new Set();
    }

    set.add(type);

    calculationTypesMap.set(rule, set);
};

export const ifTypeInUse = (calculationTypesMap: Map<string, Set<CalculationType>>, rule: string, type: CalculationType) : boolean => {
    const set = calculationTypesMap.get(rule);
    if(!set) return false;
    return set.has(type);
};

export const handeInfiniteLoop = (level: number) => {
    if(level > MAX_LEVEL) {
        throw new Error('MAX LEVEL EXCEEDED!');
    }
};

/*
function hasDependencyPath(start: string, target: string, graph: IBayesianNetwork, visited = new Set<string>()): boolean {
    if (start === target) return true;
    if (visited.has(start)) return false;

    visited.add(start);
    const children = Object.keys(graph).filter(n =>
        graph[n].parents.includes(start)
    );

    for (const child of children) {
        if (hasDependencyPath(child, target, graph, visited)) return true;
    }

    return false;
}

function areNodesIndependent(nodes: string[], graph: IBayesianNetwork): boolean {
    for (let i = 0; i < nodes.length; i++) {
        for (let j = 0; j < nodes.length; j++) {
            if (i === j) continue;
            if (hasDependencyPath(nodes[i], nodes[j], graph)) return false;
        }
    }
    return true;
}
*/

export const sortLettersPerGraph = (letters: string[], graph: IBayesianNetwork) => {

    letters.sort((letter1, letter2) => {
        const node1 = graph[letter1.replace('~', '')];
        const node2 = graph[letter2.replace('~', '')];

        const level1 = node1?.level ?? 0;
        const level2 = node2?.level ?? 0;
        return level2 - level1;
    })
};

export const findMarginComplementRules = (results: Map<string, number>, rule: string) => {
    const letters = new Set(rule.split(','));
    const rules = [...results.keys()];
    const result: string[] = [];

    for(const _rule of rules) {
        if (rule === _rule) continue;
        const ruleLetters = new Set(_rule.split(/[|,]/));
        if(!isSubset(ruleLetters, letters)) continue;

        const lettersNotInRule = new Set<string>();
        for(const item of ruleLetters) {
            if(!letters.has(item)) {
                lettersNotInRule.add(item);
            }
        }
        result.push(...lettersNotInRule);
    }

    return result;
};

export function getDarkColor() {
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += Math.floor(Math.random() * 10);
    }
    return color;
}


/*export const areNodesIndependent = (
    letters: string[],
    graph: IBayesianNetwork
) : boolean => {
    for(const letter of letters) {
        const node = graph[letter];
        if(!node) continue;

        if(node.parents.length > 0) return false;
    }

    return true;
};*/


export const areNodesIndependent = (letters: string[], graph: IBayesianNetwork): boolean => {
    for (let i = 0; i < letters.length; i++) {
        const a = letters[i].replace('~', '');
        for (let j = 0; j < letters.length; j++) {
            if (i === j) continue;
            const b = letters[j].replace('~', '');
            const aParents = new Set(graph[a]?.parents ?? []);
            if (aParents.has(b)) return false;
        }
    }
    return true;
};
